import { render, staticRenderFns } from "./PicturesGallery.vue?vue&type=template&id=5f72b24c&scoped=true"
import script from "./PicturesGallery.vue?vue&type=script&lang=js"
export * from "./PicturesGallery.vue?vue&type=script&lang=js"
import style0 from "./PicturesGallery.vue?vue&type=style&index=0&id=5f72b24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72b24c",
  null
  
)

export default component.exports